import React from 'react';
import styled from 'styled-components';
import Heading from '../components/heading';
import Container from "../components/container";


const StyledWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 0;
`;

const StyledUl = styled.ul`
    list-style-type: none;
    padding: 0;
    margin: 0;
    width: 20vw;
    text-align: center;
`;

const StyledLi = styled.li`
    font-size: 2vw;
    line-height: 3vw;
    font-family: "Lato";
    font-weight: 100;
    margin-bottom: 35px;

    @media (orientation: portrait) {
        font-weight: 200;
        font-size: 3.5vw;
        line-height: 4vw;
    }
`;


const Skills = () => (

    <Container>
        <Heading>Skills</Heading>
        <StyledWrapper>
            <StyledUl>
                <StyledLi>HTML</StyledLi>
                <StyledLi>JS</StyledLi>
                <StyledLi>React</StyledLi>
                <StyledLi>CSS</StyledLi>
                <StyledLi>Vue.js</StyledLi>
            </StyledUl>
            <StyledUl>
                <StyledLi>Wordpress</StyledLi>
                <StyledLi>JUnit</StyledLi>
                <StyledLi>Jira</StyledLi>
                <StyledLi>AWS</StyledLi>
                <StyledLi>Webpack</StyledLi>
            </StyledUl>
            <StyledUl>
                <StyledLi>Kubernetes</StyledLi>
                <StyledLi>Docker</StyledLi>
                <StyledLi>Linux</StyledLi>
                <StyledLi>Python</StyledLi>
                <StyledLi>GIT</StyledLi>
            </StyledUl>
        </StyledWrapper>
    </Container>
);

export default Skills;